import jsPDF from "jspdf";
import html2canvas from 'html2canvas';
import ReactGA from "react-ga4";

export function downloadFile(fileName: string) {
    ReactGA.event({
      category: "custom",
      action: "downloadFile_" + fileName,
    });

    const fileUrl = `${window.location.origin}/downloads/${fileName}`;
  
    // Creating a temporary anchor (`<a>`) element
    const anchor = document.createElement('a');
    anchor.href = fileUrl;
    anchor.download = ''; // This can be set to a specific filename if desired
    document.body.appendChild(anchor); // Append the anchor to the document
    anchor.click(); // Programmatically trigger a click on the anchor
  
    document.body.removeChild(anchor); // Clean up by removing the anchor
  }

  export function downloadText(fileName: string, fileContent: string) {
    // Create a Blob from the file content
    const blob = new Blob([fileContent], { type: 'text/plain' });
  
    // Create a temporary URL for the Blob
    const fileUrl = URL.createObjectURL(blob);
  
    // Create a temporary anchor (`<a>`) element
    const anchor = document.createElement('a');
    anchor.href = fileUrl;
    anchor.download = fileName; // Set the download attribute with the filename
    document.body.appendChild(anchor); // Append the anchor to the document
    anchor.click(); // Programmatically trigger a click on the anchor
  
    // Clean up by removing the anchor and revoking the object URL
    document.body.removeChild(anchor);
    URL.revokeObjectURL(fileUrl);
  }
  
  const printHTML = async (elementId: string, fileName: string = 'document.pdf'): Promise<void> => {
    const element = document.getElementById(elementId);
  
    if (!element) {
      console.error(`Element with id "${elementId}" not found`);
      return;
    }
  
    try {
      // Use html2canvas to capture the HTML element as an image
      const canvas = await html2canvas(element);
      const imageData = canvas.toDataURL('image/png');
  
      // Create a new jsPDF document in portrait mode
      const pdf = new jsPDF('p', 'pt', 'a4');
  
      // Get dimensions of the PDF page
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
  
      // Get dimensions of the canvas (image)
      const imageWidth = canvas.width;
      const imageHeight = canvas.height;
  
      // Calculate the ratio to fit the image into the PDF width
      const ratio = pageWidth / imageWidth;
      const scaledHeight = imageHeight * ratio;
  
      let position = 0;
  
      // If scaledHeight is greater than the PDF height, we need to split into multiple pages
      while (position < scaledHeight) {
        // Add the image to the PDF, starting at the current position
        pdf.addImage(
          imageData,
          'PNG',
          0,
          position ? -position : 0, // Negative y to shift the image upward for multi-page
          pageWidth,
          scaledHeight
        );
  
        // Move the position for the next page
        position += pageHeight;
  
        // Add a new page if the content overflows the current page
        if (position < scaledHeight) {
          pdf.addPage();
        }
      }
  
      // Save the generated PDF
      pdf.save(fileName);
    } catch (error) {
      console.error('Error generating PDF:', error);
    }
  };
  
  export default printHTML;
  